import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const HudrationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getHudration: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
      }
    >({
      query: ({ search } = {}) => ({
        url: `${END_POINTS.getHydration}${
          search && search.trim() !== ""
            ? `?search=${encodeURIComponent(search)}`
            : ""
        }`,
        method: "GET",
      }),
    }),
    getHudrationById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getHydrationById}/${id}/`,
        method: "GET",
      }),
    }),
    addHudration: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addHydration,
        method: "POST",
        body,
      }),
    }),

    updateHudration: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.addHydration}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteHudration: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteHydration}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetHudrationQuery,
  useLazyGetHudrationByIdQuery,
  useAddHudrationMutation,
  useUpdateHudrationMutation,
  useDeleteHudrationMutation,
} = HudrationApi;
